module.exports = __webpack_public_path__ + "static/img/logow.331bbb27.png";